// FooterMenu Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class FooterMenu extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      info: PropTypes.string,
      onClickLogout: PropTypes.func,
      date: PropTypes.object,
      timeTaken: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      title: null,
      info: null,
      onClickLogout: null,
      date: null,
      timeTaken: 0
    }
  }

  render () {
    const date = this.props.date
    return (
      <div className='footer-menu'>
        <IconButton
          icon='time-logout'
          title='time.footer.logout'
          size='big'
          canHover
          className='time-logout'
          onClick={this._onClickLogout.bind(this)}
        />
        <div className='info'>
          <span className='day'>
            {DateUtil.getDisplayWeekDay(date)}{' '}
            {DateUtil.getDisplayFullMonth(date)} {DateUtil.getDisplayDay(date)}
          </span>
          <span className='hour'>
            {Util.convertMinutesToHour(this.props.timeTaken)}
            <IntlMessage ident='time.footer.thisWeek' />
          </span>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onClickLogout (e) {
    e.preventDefault()

    if (this.props.onClickLogout) {
      this.props.onClickLogout()
    }
  }
}

export default FooterMenu
